export default [{
  name: 'platform-charge',
  path: 'platform-charge',
  component: () => import('./charge-manage/index.vue'),
  meta: {
    code: '/pay/up.htm'
  }
}, {
  name: 'platform-business',
  path: 'platform-business',
  component: () => import('./business-manage/index.vue'),
  meta: {
    code: '/pay/down.htm'
  }
}, {
  name: 'platform-widthdraw',
  path: 'platform-widthdraw',
  component: () => import('./withdraw-list/index.vue'),
  meta: {
    code: '/order/withdraw.htm'
  }
}, {
  name: 'invite-rewards',
  path: 'invite-rewards',
  component: () => import('./invite-rewards/index.vue'),
  meta: {
    code: '/pay/reward.htm'
  }
}, {
  name: 'account-charge',
  path: 'account-charge',
  component: () => import('./account-charge/index.vue'),
  meta: {
    code: '/pay/reward.htm'
  }
}, {
  name: 'refund',
  path: 'refund',
  component: () => import('./refund/index.vue'),
  meta: {
    code: '/pay/reward.htm'
  }
}, {
  name: 'winning-record',
  path: 'winning-record',
  component: () => import('./winning-record/index.vue'),
  meta: {
    code: '/pay/reward.htm'
  }
}];



// WEBPACK FOOTER //
// ./src/views/platform-account-management/index.route.js